<template>
  <van-cell
    class="header"
    :title="title"
    title-class="title"
    :value="value"
    value-class="value"
    center
  />
</template>

<script>
export default {
  name: 'CommonHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding: 18px 16px;
  background: none;
  .title {
    text-align: left;
    font-weight: bold;
    font-size: 32px;
    color: black;
  }
  .value {
    font-size: 28px;
    color: black;
  }
}
</style>
